// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1616a5fc","453":"d03b47b2","732":"61cf27a5","977":"580cee7e"}[chunkId] + ".chunk.js";
};